import React from 'react';
import iconCheck from '@static/images/icon_check.svg';
import { Button } from '../../Button/index.ts';
import { Image } from '../../Image/index.ts';
import styles from './DialogConfirmButton.module.scss';
/** Confirm button for a dialog. Defaults to a check icon; pass children to override. */ export function DialogConfirmButton({ onClick, disabled = false, children }) {
    return /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        size: 'md',
        disabled: disabled,
        fullWidth: true,
        onClick: onClick,
        "data-testid": "dialog-confirm-button"
    }, children !== null && children !== void 0 ? children : /*#__PURE__*/ React.createElement(Image, {
        className: styles.icon,
        image: {
            src: iconCheck,
            alt: 'strings:colonistCommon.buttons.confirm'
        }
    }));
}
